import styled from 'styled-components';

const ContainerWrapper = styled.div`
  display: flex;
  flex-flow: column;
  margin: 5px;
`;

export default ContainerWrapper;
